import React, { useEffect, useState, useCallback } from "react";
import {
  Box,
  Card,
  CardContent,
  IconButton,
  Stack,
  Tooltip,
  Typography,
} from "@mui/material";
import _ from "lodash";
//import SearchIcon from "@mui/icons-material/Search";
//import { DISPLAY_PAGE_SIZE } from "../../../constants/constants"
import TokenService from "../../../service/TokenService";
import ExportToExcelCustomButton from "../../../components/ExportToExcelButtonCustom";
import ExportToPDFCustomButton from "../../../components/ExportPDFfromTable.js";
import ListDynamicTable from "../../../CustomComponant/ListDynamicTable";
import dayjs from "dayjs";
import { DISPLAY_PAGE_SIZE, REPORT_TYPE } from "../../../constants/constants.js";
import apiClient from "../../../BaseUrl/apiClient.js"
import SearchTextField from "../../../CustomComponant/SearchTextField.js";
import SearchIcon from "@mui/icons-material/Search";
import AssessmentIcon from "@mui/icons-material/Assessment";
//import SearchTextField from "../../../CustomComponant/SearchTextField";
function PoReport({ consignee, reporttype, reportsubtype, heading }) {
  const [reportData, setReportData] = useState([]);
  const [reportAllData, setReportAllData] = useState([]);
  const [srcinddata, setSrcinddata] = useState("");

  const [totalRows, setTotalRows] = useState(0);
  const [currentPage, setCurrentPage] = useState(1); // set the current page
  const pageSize = DISPLAY_PAGE_SIZE;
  const tokenServiceDetails = TokenService.getUserDetails();
  const uname = tokenServiceDetails?.uname;
  const [pgHeader, setpgHeader] = useState("");

  // const [pageLoader, setPageLoader] = useState(true);

  const today = dayjs().startOf("day");

  const [columns, setColumns] = useState([""]);
  const [columnNames, setColumnNames] = useState([""]);

  // Debounced search function
  const fetchData = useCallback(
    _.debounce(async (searchTerm) => {
      let apiEndPoint = "";
      try {
        // setPageLoader(true);
        if (reporttype === REPORT_TYPE.PO_NOT_GENERATED) {
          //setColumns(["totaldata","ConsigneeCode","indentnumber","indreceiptdate", "daydiff","itemname",]);
          // setColumnNames(["Total Rows","Consignee","Indent Number","Indent Date", "Pending Days from Indent","Item Name",]);
          setColumns([
            //"ConsigneeCode",
            "Shop",
            "indentnumber",
            "itemname",
            "indreceiptdate",
            "daydiff",
            "urgency",

          ]);
          setColumnNames([
            // "Consignee Code",
            "Consignee Name",
            "Indent Number",
            "Item Name",
            "Indent Date",
            "Pending Days from Indent",
            "Urgency",
          ]);

          apiEndPoint = "/getAllIndentList";
        } else if (reporttype === REPORT_TYPE.ITEM_NOT_RECEIVED) {
          setColumns([
            //"POConsignee",
            "Shop",
            "IndentNumber",
            "ponumber",
            "poitemname",
            "podate",

            //"party_contact",
            "daydiff",
            "DPdate",
            "dpdaydiff",
            "party_name",

          ]); // keys from your data objects
          setColumnNames([
            //"Consignee Code",
            "Consignee Name",
            "Indent Number",
            "PO Number",
            "Item Name",
            "PO Date",

            //"Party Contact",
            "Days Pending from PO",
            "DP Date",
            "Remaining Days for DP",
            "Supplier",

          ]);
          apiEndPoint = "/getitemNotReceivedList";
        } else if (reporttype === REPORT_TYPE.SUITABILITY_PENDING) {
          setColumns([
            // "consignee",
            "Shop",
            "ponumber",
            "poitemname",
            // "podate",
            "getpassnumber",
            "itemReceivedDate",
            "daydiff",
            // "DPdate",
            "pushdate",
            "pushdiff",

          ]); // keys from your data objects
          setColumnNames([
            // "Consignee Code",
            "Consignee Name",
            "PO Number",
            "Item Name",
            // "PO Date",
            "Gate Pass/Memo Number",
            "Item Receiving Date ",
            "Pending Days from Receiving",
            // "DP Date",
            "Suitability Push Date",
            "Pending Days from Push Date",

          ]);
          apiEndPoint = "/getsuitabilitypendingList";
        } else if (reporttype === REPORT_TYPE.BILL_RECEIVED_PENDING) {
          setColumns([
            //"consignee",
            "Shop",
            "poNumber",
            "POItemName",
            // "PODate",

            //"DPDate",
            "SuitabilityDate",
            "daydiff",

          ]); // keys from your data objects
          setColumnNames([
            //"Consignee Code",
            "Consignee Name",
            "PO Number",
            "Item Name",
            // "PO Date",

            //"DP Date",
            "Suitability Date",
            "Pending Days from Item Suitability",
          ]);
          apiEndPoint = "/getbillpendingList";
        } else if (reporttype === REPORT_TYPE.BILL_PASSING_PENDING) {
          setColumns([
            //"consignee",
            "Shop",
            "ponumber",
            "POItemName",
            "billnumber",
            "billdate",
            "billreceiptdate",
            "nodaldate",
            "daydiff",
          ]); // keys from your data objects
          setColumnNames([
            //"Consignee Code",
            "Consignee Name",
            "PO Number",
            "Item Name",
            "Bill Number",
            "Bill Date",
            "Bill Receiving Date",
            "Bill Push to COS/G",
            "Pending Days ",
          ]);
          apiEndPoint = "/pendingatCOSG";
        } else if (reporttype === REPORT_TYPE.CRN_PENDING) {
          setColumns([
            //"consignee",
            "Shop",
            "ponumber",
            "POItemName",
            "billnumber",
            "billdate",
            "billpassingdate",
            "daydiff",
          ]); // keys from your data objects
          setColumnNames([
            //"Consignee Code",
            "Consignee Name",
            "PO Number",
            "Item Name",
            "Bill Number",
            "Bill Date",
            "Bill Passing Date",
            "Pending Days from Bill Passing",
          ]);
          apiEndPoint = "/pendingforaccount";
        } else if (reporttype === REPORT_TYPE.PAYMENT_PENDING) {
          setColumns([
            //"consignee",
            "Shop",
            "ponumber",
            "POItemName",
            "billnumber",
            "billdate",
            "crndate",
            "billsenttoaccountdate",
            "daydiff",
          ]); // keys from your data objects
          setColumnNames([
            //"Consignee Code",
            "Consignee Name",
            "PO Number",
            "Item Name",
            "Bill Number",
            "Bill Date",
            "CRN Date",
            "Hardcopy Sent to Account Date",
            "Pending Days from From CRN",
          ]);
          apiEndPoint = "/paymentpending";
        } else if (reporttype === REPORT_TYPE.PAID) {
          //			co6number	co6date	co7number	co7date	paymentdate	daydiff
          setColumns([
            // "consignee",
            "Shop",
            "ponumber",

            "PODate",
            "DPDate",
            "dpextension",
            "POQty",
            "POValue",

            "party_name",
            "POItemName",
            "billnumber",
            "billdate",
            "co6number",
            "co6date",
            "co7number",
            "co7date",
            "paymentdate",
          ]); // keys from your data objects
          setColumnNames([
            // "Consignee Code",
            "Consignee Name",
            "PO Number",
            "PO Date",
            "DP Date",
            "DP Extensions",
            "PO Qty",
            "PO Value",

            "Supplier",
            "Item Name",
            "Bill Number",
            "Bill Date",
            "CO6 Number",
            "CO6 Date",
            "CO7 Number",
            "CO7 Date",
            "Payment Date",
          ]);
          apiEndPoint = "/paymentpaid";
        }
        //uname	FullName	emailid	mobilenumber	role	consignee
        else if (reporttype === REPORT_TYPE.USER_LIST) {
          //			co6number	co6date	co7number	co7date	paymentdate	daydiff
          setColumns([
            "uname",
            "FullName",
            "emailid",
            "mobilenumber",
            "role",
            //"ConsigneeCode",
            "Shop",
            "LoginDetails",
          ]); // keys from your data objects
          setColumnNames([
            "User Name",
            "User Full Name",
            "E-Mail ID",
            "Mobile Number",
            "User Type",
            //"Consignee Code",
            "Consignee Name",
            "Last Login Details",
          ]);
          apiEndPoint = "/userList";
        } else {
          //   console.error("Unsupported report type:", reporttype);
          // Optionally, set default columns or take other action here
        }
        const allDataResponse = await apiClient.post(`${apiEndPoint}`, {
          uname: uname,
          limit: "0", // No limit
          offset: "0", // No offset
          srcinddata: searchTerm, // No search term for fetching all data
        });

        const allData = allDataResponse.data;


        console.log(allData);



        const filteredData = allData.filter((subreport) => {
          // report type Indent List which PO Not Found
          if (reporttype === REPORT_TYPE.PO_NOT_GENERATED) {
            let dayDiffThreshold = 0;
            if (reportsubtype === 1) {
              dayDiffThreshold = 30;
            } else if (reportsubtype === 2) {
              dayDiffThreshold = 60;
            } else if (reportsubtype === 3) {
              dayDiffThreshold = 90;
            }

            // Apply filtering based on consignee and daydiff
            if (consignee === "Select All") {
              setpgHeader("All Indent List which PO Not Found");
              return subreport.daydiff >= dayDiffThreshold;
            } else {
              setpgHeader(
                `Indent List which PO Not Found for ${consignee}`
              );
              return (
                subreport.daydiff >= dayDiffThreshold &&
                subreport.ConsigneeCode === `${consignee}`
              );
            }
          } else if (reporttype === REPORT_TYPE.ITEM_NOT_RECEIVED) {

            if (consignee === "Select All") {
              if (reportsubtype === 1) {
                return dayjs(subreport.DPdate).isBefore(today);
              }
              if (reportsubtype === 2) {
                return (
                  dayjs(subreport.DPdate).isAfter(today) ||
                  dayjs(subreport.DPdate).isSame(today)
                );
              }
              if (reportsubtype === 3) {
                return (
                  dayjs(subreport.DPdate).isBetween(today, dayjs().add(1, 'week'), null, '[)')
                );
              }


            } else {
              if (reportsubtype === "All Data") {
                return subreport.POConsignee === `${consignee}`;
              }


              if (reportsubtype === 1) {
                return (
                  dayjs(subreport.DPdate).isBefore(today) &&
                  subreport.POConsignee === `${consignee}`
                );
              }
              if (reportsubtype === 2) {
                return (
                  (dayjs(subreport.DPdate).isAfter(today) ||
                    dayjs(subreport.DPdate).isSame(today))
                  &&
                  subreport.POConsignee === `${consignee}`
                );
              }
              if (reportsubtype === 3) {
                return (
                  dayjs(subreport.DPdate).isBetween(today, dayjs().add(1, 'week'), null, '[)')
                  &&
                  subreport.POConsignee === `${consignee}`
                );
              }

            }
          } else if (reporttype === REPORT_TYPE.SUITABILITY_PENDING) {
            let dayDiffThreshold = 0;
            if (reportsubtype === 1) {
              dayDiffThreshold = 7;
            } else if (reportsubtype === 2) {
              dayDiffThreshold = 15;
            } else if (reportsubtype === 3) {
              dayDiffThreshold = 30;
            }

            // Apply filtering based on consignee and daydiff
            if (consignee === "Select All") {
              setpgHeader("All Suitability List");
              return subreport.daydiff >= dayDiffThreshold;
            } else {
              setpgHeader(`Suitability List for ${consignee}`);
              return (
                subreport.daydiff >= dayDiffThreshold &&
                subreport.consignee === `${consignee}`
              );
            }
          } else if (reporttype === REPORT_TYPE.BILL_RECEIVED_PENDING) {
            let dayDiffThreshold = 0;
            if (reportsubtype === 1) {
              dayDiffThreshold = 7;
            }

            // Apply filtering based on consignee and daydiff
            if (consignee === "Select All") {
              setpgHeader("All Bill Received Pending List");
              return subreport.daydiff >= dayDiffThreshold;
            } else {
              setpgHeader(`Bill Received Pending List for ${consignee}`);
              return (
                subreport.daydiff >= dayDiffThreshold &&
                subreport.consignee === `${consignee}`
              );
            }
          } else if (reporttype === REPORT_TYPE.BILL_PASSING_PENDING) {
            let dayDiffThreshold = 0;
            if (reportsubtype === 1) {
              dayDiffThreshold = 7;
            }

            // Apply filtering based on consignee and daydiff
            if (consignee === "Select All") {
              setpgHeader("All Bill Passing Pending List");
              return subreport.daydiff >= dayDiffThreshold;
            } else {
              setpgHeader(`Bill Passing Pending List for ${consignee}`);
              return (
                subreport.daydiff >= dayDiffThreshold &&
                subreport.consignee === `${consignee}`
              );
            }
          } else if (reporttype === REPORT_TYPE.CRN_PENDING) {
            let dayDiffThreshold = 0;
            if (reportsubtype === 0) {
              dayDiffThreshold = 0;
            } else if (reportsubtype === 1) {
              dayDiffThreshold = 7;
            }

            // Apply filtering based on consignee and daydiff
            if (consignee === "Select All") {
              setpgHeader("All CRN Pending List");
              return subreport.daydiff >= dayDiffThreshold;
            } else {
              setpgHeader(`CRN Pending List for ${consignee}`);
              return (
                subreport.daydiff >= dayDiffThreshold &&
                subreport.consignee === `${consignee}`
              );
            }
          } else if (reporttype === REPORT_TYPE.PAYMENT_PENDING) {
            let dayDiffThreshold = 0;
            if (reportsubtype === 1) {
              dayDiffThreshold = 10;
            }

            // Apply filtering based on consignee and daydiff
            if (consignee === "Select All") {
              setpgHeader("All Payment Pending List");
              return subreport.daydiff >= dayDiffThreshold;
            } else {
              setpgHeader(`Payment Pending List for ${consignee}`);
              return (
                subreport.daydiff >= dayDiffThreshold &&
                subreport.consignee === `${consignee}`
              );
            }
          } else if (reporttype === REPORT_TYPE.PAID) {

  let dayDiffThreshold = 0;

  if (reportsubtype === 1) dayDiffThreshold = 7;
  else if (reportsubtype === 2) dayDiffThreshold = 15;
  else if (reportsubtype === 3) dayDiffThreshold = 30;
  else if (reportsubtype === 4) dayDiffThreshold = 60;
  else if (reportsubtype === 5) dayDiffThreshold = 90;
  else if (reportsubtype === 6) dayDiffThreshold = 180;
  else if (reportsubtype === 7) dayDiffThreshold = 365;

  if (consignee === "Select All") {

    setpgHeader(
      `All Payment Paid List Older Than ${dayDiffThreshold} Days`
    );

    return subreport.daydiff >= dayDiffThreshold;

  } else {

    setpgHeader(
      `Payment Paid List for ${consignee} Older Than ${dayDiffThreshold} Days`
    );

    return (
      subreport.daydiff >= dayDiffThreshold &&
      subreport.Shop === `${consignee}`
    );

  }
}

          // If report type doesn't match, return all data (no filtering)
          return true;
        });

        setReportAllData(filteredData);

        const totalItems = filteredData.length;

        // console.log(totalItems);

        setTotalRows(totalItems);
        const startIndex = (currentPage - 1) * pageSize;
        const endIndex = startIndex + pageSize;
        setReportData(filteredData.slice(startIndex, endIndex));
      } catch (error) {
        setReportData([]);
        setTotalRows(0);
      } finally {
        //setPageLoader(false);
      }
    }, 300),
    [
      uname,
      currentPage,
      pageSize,
      columns,
      columnNames,
      reporttype,
      reportsubtype,
      srcinddata,
    ]
  );

  useEffect(() => {
    fetchData(srcinddata);
  }, [reporttype, reportsubtype, srcinddata, currentPage]);

  // useEffect(() => {
  //   // Fetch data when currentPage changes
  //   fetchData(srcinddata);
  // }, [currentPage]);

  // if (pageLoader) {
  //   return (
  //     <div className="loaderContainer">
  //       {" "}
  //       <CircularProgress />{" "}
  //     </div>
  //   );
  // }

  return (
  <Box
    sx={{
      width: "100%",
      maxWidth: "100%",
      minWidth: 0,
      boxSizing: "border-box",
      overflowX: "hidden",
    }}
  >
    <Card
      elevation={0}
      sx={{
        width: "100%",
        maxWidth: "100%",
        minWidth: 0,
        borderRadius: { xs: 2, sm: 2.5, md: 3 },
        overflow: "hidden",
        border: "1px solid #dbe5f0",
        background: "#ffffff",
        boxShadow: "0 6px 24px rgba(13, 71, 161, 0.08)",
      }}
    >
      {/* =====================================================
          HEADER
      ====================================================== */}
      <Box
        sx={{
          position: "relative",
          px: { xs: 1.5, sm: 2.5, md: 3 },
          py: { xs: 1.5, sm: 2, md: 2.3 },
          background:
            "linear-gradient(135deg,#0d47a1 0%,#1565c0 48%,#1976d2 100%)",
          color: "#fff",
          overflow: "hidden",

          "&::after": {
            content: '""',
            position: "absolute",
            width: { xs: 100, sm: 150, md: 200 },
            height: { xs: 100, sm: 150, md: 200 },
            right: { xs: -45, sm: -55, md: -70 },
            top: { xs: -55, sm: -75, md: -100 },
            borderRadius: "50%",
            background: "rgba(255,255,255,0.08)",
          },
        }}
      >
        <Stack
          direction="row"
          alignItems="center"
          spacing={{ xs: 1, sm: 1.5 }}
          sx={{
            position: "relative",
            zIndex: 1,
            minWidth: 0,
          }}
        >
          {/* Icon */}
          <Box
            sx={{
              width: { xs: 40, sm: 46, md: 50 },
              height: { xs: 40, sm: 46, md: 50 },
              minWidth: { xs: 40, sm: 46, md: 50 },
              borderRadius: { xs: 1.8, sm: 2.2 },
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              background: "rgba(255,255,255,0.16)",
              border: "1px solid rgba(255,255,255,0.25)",
              backdropFilter: "blur(8px)",
              boxShadow: "0 4px 12px rgba(0,0,0,0.12)",
            }}
          >
            <AssessmentIcon
              sx={{
                fontSize: { xs: 21, sm: 25, md: 28 },
              }}
            />
          </Box>

          {/* Heading */}
          <Box
            sx={{
              minWidth: 0,
              flex: 1,
            }}
          >
            <Typography
              sx={{
                fontWeight: 900,
                fontSize: {
                  xs: "0.98rem",
                  sm: "1.15rem",
                  md: "1.3rem",
                },
                lineHeight: 1.25,
                overflowWrap: "anywhere",
                wordBreak: "break-word",
              }}
            >
              {heading || "Purchase Order Report"}
            </Typography>

            <Typography
              sx={{
                mt: 0.4,
                fontSize: {
                  xs: "0.68rem",
                  sm: "0.78rem",
                  md: "0.84rem",
                },
                opacity: 0.88,
                overflowWrap: "anywhere",
                wordBreak: "break-word",
              }}
            >
              Detailed purchase & payment information
            </Typography>
          </Box>
        </Stack>
      </Box>

      {/* =====================================================
          CONTENT
      ====================================================== */}
      <CardContent
        sx={{
          p: {
            xs: 1.2,
            sm: 1.8,
            md: 2.5,
          },
          "&:last-child": {
            pb: {
              xs: 1.2,
              sm: 1.8,
              md: 2.5,
            },
          },
          width: "100%",
          maxWidth: "100%",
          minWidth: 0,
          boxSizing: "border-box",
        }}
      >
        {/* ===================================================
            SEARCH SECTION
        ==================================================== */}
        {currentPage === 1 &&
        reporttype !== REPORT_TYPE.USER_LIST ? (
          <Box
            sx={{
              width: "100%",
              maxWidth: "100%",
              minWidth: 0,
              boxSizing: "border-box",
              mb: { xs: 1.5, sm: 2 },

              p: {
                xs: 1,
                sm: 1.3,
                md: 1.6,
              },

              borderRadius: {
                xs: 1.8,
                sm: 2,
              },

              border: "1px solid #dce6f2",

              background:
                "linear-gradient(135deg,#f3f8ff 0%,#ffffff 100%)",

              boxShadow:
                "0 2px 8px rgba(13,71,161,0.04)",

              "& .MuiInputBase-root": {
                background: "#fff",
              },
            }}
          >
            <SearchTextField
              label={
                reporttype === REPORT_TYPE.PO_NOT_GENERATED
                  ? "Indent Number"
                  : "PO Number"
              }
              value={srcinddata}
              title={
                reporttype === REPORT_TYPE.PO_NOT_GENERATED
                  ? "Enter Indent Number"
                  : "Enter PO Number"
              }
              onChange={(e) =>
                setSrcinddata(e.target.value)
              }
              adornment={
                <Tooltip
                  title={
                    reporttype === REPORT_TYPE.PO_NOT_GENERATED
                      ? "Search Indent"
                      : "Search PO"
                  }
                >
                  <IconButton
                    size="small"
                    sx={{
                      color: "#1565c0",
                      background:
                        "linear-gradient(135deg,#e3f2fd,#bbdefb)",

                      border:
                        "1px solid rgba(21,101,192,0.15)",

                      "&:hover": {
                        background:
                          "linear-gradient(135deg,#bbdefb,#90caf9)",
                      },
                    }}
                  >
                    <SearchIcon
                      sx={{
                        fontSize: {
                          xs: 19,
                          sm: 21,
                        },
                      }}
                    />
                  </IconButton>
                </Tooltip>
              }
            />
          </Box>
        ) : null}

        {/* ===================================================
            REPORT TABLE
        ==================================================== */}
        {columns?.length && columnNames?.length ? (
          <Box
            sx={{
              width: "100%",
              maxWidth: "100%",
              minWidth: 0,
              boxSizing: "border-box",

              border: "1px solid #dce6f2",
              borderRadius: {
                xs: 1.5,
                sm: 2,
                md: 2.5,
              },

              background: "#fff",

              overflow: "hidden",

              boxShadow:
                "0 2px 10px rgba(13,71,161,0.04)",

              "& *": {
                boxSizing: "border-box",
              },

              /* Prevent child table from expanding page */
              "& table": {
                width: "100% !important",
                maxWidth: "100% !important",
                minWidth: "0 !important",
                tableLayout: "fixed !important",
              },

              "& th": {
                whiteSpace: "normal !important",
                overflowWrap: "anywhere !important",
                wordBreak: "break-word !important",
              },

              "& td": {
                whiteSpace: "normal !important",
                overflowWrap: "anywhere !important",
                wordBreak: "break-word !important",
              },
            }}
          >
            <ListDynamicTable
              columns={columns}
              columnNames={columnNames}
              data={reportData}
              totalRows={totalRows}
              pageSize={pageSize}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              showProceed={false}
            />
          </Box>
        ) : null}

        {/* ===================================================
            EXPORT SECTION
        ==================================================== */}
        <Box
          sx={{
            width: "100%",
            maxWidth: "100%",
            minWidth: 0,
            mt: {
              xs: 1.8,
              sm: 2.2,
              md: 2.5,
            },
            p: {
              xs: 1,
              sm: 1.2,
              md: 1.5,
            },

            borderRadius: {
              xs: 1.8,
              sm: 2,
            },

            background:
              "linear-gradient(135deg,#f7faff 0%,#ffffff 100%)",

            border: "1px solid #e1e9f3",
          }}
        >
          <Stack
            direction={{
              xs: "column",
              sm: "row",
            }}
            spacing={{
              xs: 1,
              sm: 1.5,
            }}
            justifyContent="center"
            alignItems="stretch"
            sx={{
              width: "100%",
              maxWidth: "100%",
            }}
          >
            <Box
              sx={{
                width: {
                  xs: "100%",
                  sm: "auto",
                },
                minWidth: 0,
              }}
            >
              <ExportToExcelCustomButton
                data={reportAllData}
                fileName={"POList"}
                columns={columns}
                columnNames={columnNames}
                buttonTitle="Export to Excel"
              />
            </Box>

            <Box
              sx={{
                width: {
                  xs: "100%",
                  sm: "auto",
                },
                minWidth: 0,
              }}
            >
              <ExportToPDFCustomButton
                data={reportAllData}
                fileName={"POList"}
                columns={columns}
                columnNames={columnNames}
                buttonTitle="Export to PDF"
                pageHeader={pgHeader}
              />
            </Box>
          </Stack>
        </Box>
      </CardContent>
    </Card>
  </Box>
);
}

export default PoReport;
